<template>
  <a
    href="#top"
    class="scroll-to-top"
    :class="{ 'scroll-to-top__active': isActive }"
    :style="{ top: `${x}px`, left: `${y}px` }"
    @click="onClick"
  />
</template>

<script>
export default {
  name: 'ScrollToTop',
  props: {
    ShowIn: {
      default: 200,
      type: Number
    }
  },
  data() {
    return {
      isActive: false,
      limit: 0,
      ref: null,
      x: 0,
      y: 0
    }
  },
  created() {
    if (this.execute()) {
      this.activate()
    }
  },
  methods: {
    execute() {
      this.ref = document.querySelector('footer')

      if (!this.ref) {
        return false
      }

      this.limit = this.ref.getBoundingClientRect().top - this.ShowIn

      window.addEventListener('scroll', this.activate.bind(this), { passive: false })
      window.addEventListener('resize', this.activate.bind(this), { passive: false })
      document.body.addEventListener('scroll', this.activate.bind(this), { passive: false })

      return true
    },
    activate() {
      this.x = window.innerHeight - 90
      this.y = window.innerWidth - 90

      this.isActive = this.limit > this.ref.getBoundingClientRect().top
    },
    onClick() {
      this.isActive = false

      setTimeout(() => {
        document.getElementById('menu-icon').blur()
      }, 200)
      window.scrollTop = 0
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0// For Chrome, Firefox, IE and Opera
    }
  }
}
</script>
